class AlgoliaCard extends HTMLElement {
  constructor () {
    super()

    const productVariantButtons = this.querySelectorAll('.js-VariantButton_Button')
    const atcForm = this.querySelector('.prd-Card_Offers')
    const mobileQuickTrigger = this.querySelector('.js-QuickAddToCart_Trigger')

    this.modalEl = document.querySelector('[data-product-card-external-el="quickAddContainer"]')
    this.modalInner = document.querySelector('[data-product-card-external-el="quickAddInner"]')

    atcForm?.addEventListener('click', e => {
      if (e.target.classList.contains('prd-CardOffer_VariableList')) {
        e.preventDefault()
        e.stopImmediatePropagation()
      }
    })

    this.setupWindowNavigation()
    this.setupVariantButtons(productVariantButtons)

    mobileQuickTrigger?.addEventListener('click', e => {
      e.preventDefault()
      e.stopImmediatePropagation()

      this.handleOpen(e)
    })
  }

  setupWindowNavigation () {
    const windowNavigation = this.querySelector('.js-Quickbuy_Windows')
    if (!windowNavigation) return

    const navButtons = windowNavigation.querySelectorAll('.js-CardOffer_WindowNav')
    const navButtonPrev = windowNavigation.querySelector(
      '.js-CardOffer_WindowNav[data-direction="prev"]',
    )
    const navButtonNext = windowNavigation.querySelector(
      '.js-CardOffer_WindowNav[data-direction="next"]',
    )

    navButtons.forEach(navButton => {
      navButton.addEventListener('click', e => {
        e.preventDefault()
        e.stopImmediatePropagation()

        const allWindows = windowNavigation.querySelectorAll('.js-Quickbuy_Window')
        const activeWindowIndex = windowNavigation.querySelector(
          '.js-Quickbuy_Window.prd-CardOffer_WindowActive',
        ).dataset.windowIndex

        switch (navButton.dataset.direction) {
          case 'prev': {
            const prevWindow = activeWindowIndex * 1 - 1
            allWindows.forEach(panel => {
              if (panel.dataset.windowIndex * 1 === prevWindow) {
                panel.classList.add('prd-CardOffer_WindowActive')
              } else {
                panel.classList.remove('prd-CardOffer_WindowActive')
              }

              navButtonPrev.setAttribute('disabled', true)
              navButtonNext.removeAttribute('disabled')
            })

            break
          }

          case 'next': {
            const nextWindow = activeWindowIndex * 1 + 1
            allWindows.forEach(panel => {
              if (panel.dataset.windowIndex * 1 === nextWindow) {
                panel.classList.add('prd-CardOffer_WindowActive')
              } else {
                panel.classList.remove('prd-CardOffer_WindowActive')
              }

              navButtonNext.setAttribute('disabled', true)
              navButtonPrev.removeAttribute('disabled')
            })

            break
          }
        }
      })

      if (navButton.dataset.direction === 'prev') {
        navButton.setAttribute('disabled', true)
      }
    })
  }

  setupVariantButtons (variantButtons) {
    variantButtons.forEach(variantButton => {
      variantButton.addEventListener('click', e => {
        e.preventDefault()
        e.stopImmediatePropagation()

        const productCard = variantButton.closest('.prd-Card')
        const sel = this.querySelector('.js-VariantButton_ID')
        const variant = variantButton.dataset.productVariant
        const option = variantButton.dataset.optionId

        let variantData = false
        if (productCard.querySelector('[type="application/json"]')) {
          variantData =
            JSON.parse(productCard.querySelector('[type="application/json"]').textContent) || false
        }

        const variantSelect = variantButton
          .closest('.js-VariantButton_Container')
          .querySelector('.js-VariantButton_Select')
        if (variantSelect) {
          variantSelect.value = variant
        }

        if (sel) {
          const opts = sel.options
          const productVariantSections = this.querySelectorAll('.js-VariantButton_Container')

          if (productVariantSections.length === 2) {
            let optionValue1
            let optionValue2

            if (option === 'option1') {
              optionValue1 = variant
              optionValue2 = productCard.querySelector(
                '.js-VariantButton_Button[aria-selected="true"][data-option-id="option2"]',
              ).innerText
            } else {
              optionValue1 = productCard.querySelector(
                '.js-VariantButton_Button[aria-selected="true"][data-option-id="option1"]',
              ).innerText
              optionValue2 = variant
            }

            for (let opt, j = 0; (opt = opts[j]); j++) {
              if (
                opt.getAttribute('data-option1') === optionValue1 &&
                opt.getAttribute('data-option2') === optionValue2
              ) {
                sel.selectedIndex = j
                break
              }
            }
          } else {
            for (let opt, j = 0; (opt = opts[j]); j++) {
              if (opt.text === variant) {
                sel.selectedIndex = j
                break
              }
            }
          }
        }

        const event = new Event('change', {
          bubbles: true,
        })

        if (variantSelect) {
          variantSelect.dispatchEvent(event)
        }

        variantButtons.forEach(el => el.setAttribute('aria-selected', String(el === variantButton)))

        const productVariantSections = this.querySelectorAll('.js-VariantButton_Container')
        if (productVariantSections && productVariantSections.length === 2) {
          if (variantData) {
            this.checkVariantAvailabilty(option, variant, variantData, productCard)
          }
        }

        const productVariantSection = variantButton.closest('.js-VariantButton_Container')
        if (productVariantSection.hasAttribute('data-has-add-to-cart-trigger')) return

        if (productVariantSection.hasAttribute('data-quickbuy-trigger')) {
          const allWindows = productCard.querySelectorAll('.js-Quickbuy_Window')
          const activeWindowIndex = productCard.querySelector(
            '.js-Quickbuy_Window.prd-CardOffer_WindowActive',
          ).dataset.windowIndex
          const navButtonPrev = this.querySelector('.js-CardOffer_WindowNav[data-direction="prev"]')
          const navButtonNext = this.querySelector('.js-CardOffer_WindowNav[data-direction="next"]')

          if (activeWindowIndex < allWindows.length) {
            const nextWindow = activeWindowIndex * 1 + 1
            allWindows.forEach(variantWindow => {
              if (variantWindow.dataset.windowIndex * 1 === nextWindow) {
                variantWindow.classList.add('prd-CardOffer_WindowActive')
              } else {
                variantWindow.classList.remove('prd-CardOffer_WindowActive')
              }
            })
            navButtonPrev.removeAttribute('disabled')
            navButtonNext.setAttribute('disabled', true)
            return
          } else {
            const variantUnavailable = sel.options[sel.selectedIndex].disabled
            if (variantUnavailable) {
              const productUrl = productCard.querySelector('.prd-Card_Link').getAttribute('href')
              window.location.href = productUrl
              return
            }
          }
        }

        this.algoliaEvent(sel.value)

        const form = variantButton.closest('.js-AddToCart')
        if (form) {
          form.querySelector('.js-AddToCart_Submit').click()
        }

        const url = window.location.href
        if ((url.match(/\?/g) || []).length > 1) {
          const firstIndex = url.indexOf('?')
          const newUrl =
            url.slice(0, firstIndex + 1) + url.slice(firstIndex + 1).replace(/\?/g, '&')
          history.replaceState(null, null, newUrl)
        }
      })
    })
  }

  checkVariantAvailabilty (option, variant, variantData, productCard) {
    productCard
      .querySelector('.prd-CardOffer_Form')
      .querySelectorAll('.js-VariantButton_Button')
      .forEach(button => {
        button.style.display = 'none'
        if (button.getAttribute('aria-selected') === 'true') {
          button.style.display = 'inline-block'
        }
      })

    if (option === 'option1') {
      const secondaryOption = productCard.querySelector(
        '.js-VariantButton_Button[aria-selected="true"][data-option-id="option2"]',
      ).innerText

      if (variant === secondaryOption) return

      variantData.variants.forEach(item => {
        const option1 = productCard.querySelector(
          `.js-VariantButton_Button[data-option-id="option1"][data-product-variant=${item.option1}]`,
        )
        const option2 = productCard.querySelector(
          `.js-VariantButton_Button[data-option-id="option2"][data-product-variant=${item.option2}]`,
        )

        if (`${item.option1}` === variant) {
          if (`${item.available}` === 'true') {
            option2.classList.remove('prd-CardOffer_Button-disabled')
            option2.style.display = 'inline-block'
          } else {
            option2.classList.add('prd-CardOffer_Button-disabled')
            option2.style.display = 'inline-block'
          }
        } else if (`${item.option2}` === secondaryOption) {
          if (`${item.available}` === 'true') {
            option1.classList.remove('prd-CardOffer_Button-disabled')
            option1.style.display = 'inline-block'
          } else {
            option1.classList.add('prd-CardOffer_Button-disabled')
            option1.style.display = 'inline-block'
          }
        }
      })
    } else {
      const secondaryOption = productCard.querySelector(
        '.js-VariantButton_Button[aria-selected="true"][data-option-id="option1"]',
      ).innerText

      if (variant === secondaryOption) return

      variantData.variants.forEach(item => {
        const option1 = productCard.querySelector(
          `.js-VariantButton_Button[data-option-id="option1"][data-product-variant=${item.option1}]`,
        )
        const option2 = productCard.querySelector(
          `.js-VariantButton_Button[data-option-id="option2"][data-product-variant=${item.option2}]`,
        )
        if (`${item.option2}` === variant) {
          if (`${item.available}` === 'true') {
            option1.classList.remove('prd-CardOffer_Button-disabled')
            option1.style.display = 'inline-block'
          } else {
            option1.classList.add('prd-CardOffer_Button-disabled')
            option1.style.display = 'inline-block'
          }
        } else if (`${item.option1}` === secondaryOption) {
          if (`${item.available}` === 'true') {
            option2.classList.remove('prd-CardOffer_Button-disabled')
            option2.style.display = 'inline-block'
          } else {
            option2.classList.add('prd-CardOffer_Button-disabled')
            option2.style.display = 'inline-block'
          }
        }
      })
    }
  }

  algoliaEvent (variantId) {
    let algoliaParent = this.parentElement

    if (this.dataset.context === 'results') {
      algoliaParent = this.parentElement.parentElement
    }

    let objectIDs = algoliaParent.dataset.variantId

    if (variantId) {
      objectIDs = variantId
    }

    const data = {
      productId: this.dataset.productId,
      userToken: localStorage.getItem('aa-user-token'),
      eventType: 'conversion',
      eventSubtype: 'addToCart',
      eventName: 'Added to cart',
      index: algoliaParent.dataset.algoliaIndex,
      queryID: algoliaParent.dataset.algoliaQueryid,
      objectIDs: [objectIDs],
      objectData: [
        {
          price: this.dataset.productPrice,
          quantity: 1,
        },
      ],
      currency: Shopify.currency.active,
    }

    const event = new CustomEvent('algolia:productCard:quickAdd', {
      detail: data,
    })

    window.dispatchEvent(event)
  }

  algoliaClickEvent () {
    let algoliaParent = this.parentElement

    if (this.dataset.context === 'results') {
      algoliaParent = this.parentElement.parentElement
    }

    const objectIDs = algoliaParent.dataset.variantId

    const data = {
      productId: this.dataset.productId,
      userToken: localStorage.getItem('aa-user-token'),
      eventType: 'conversion',
      eventSubtype: 'addToCart',
      eventName: 'Added to cart',
      index: algoliaParent.dataset.algoliaIndex,
      queryID: algoliaParent.dataset.algoliaQueryid,
      objectIDs: [objectIDs],
      objectData: [
        {
          price: this.dataset.productPrice,
          quantity: 1,
        },
      ],
      positions: [Number(algoliaParent.dataset.algoliaPosition)],
      currency: Shopify.currency.active,
    }

    const event = new CustomEvent('algolia:productCard:click', {
      detail: data,
    })

    window.dispatchEvent(event)
  }

  connectedCallback () {
    this.querySelector('.prd-Card_FauxLink').addEventListener('click', e => {
      this.algoliaClickEvent()
    })

    this.setupListeners()
  }

  setupListeners () {
    this.addEventListener('click', this.setClickedProduct.bind(this))
    document.addEventListener('DOMContentLoaded', this.scrollToPreviousPosition.bind(this))
  }

  async handleOpen (e) {
    document.body.classList.add('util-move-3rd-party-up')
    this.modalEl.setAttribute('aria-hidden', 'false')

    const productUrl = e.target.closest('[data-product-url]').dataset.productUrl
    const html = await this.fetchHTML(productUrl)

    this.modalInner.innerHTML = html

    const productVariantButtons = this.modalInner.querySelectorAll('.js-VariantButton_Button')
    productVariantButtons.forEach(productVariantButton => {
      productVariantButton.addEventListener('click', e => {
        this.handleAtc(e)
      })
    })
  }

  handleAtc (e) {
    const sel = this.modalInner.querySelector('.js-VariantButton_ID')
    const variant = e.target.dataset.productVariant

    if (sel) {
      const opts = sel.options
      for (let opt, j = 0; (opt = opts[j]); j++) {
        if (opt.text === variant) {
          sel.selectedIndex = j
          break
        }
      }
    }

    this.algoliaEvent(sel.value)

    const form = e.target.closest('.js-AddToCart')
    if (form) {
      form.querySelector('.js-AddToCart_Submit').click()
    }
  }

  async fetchHTML (productUrl) {
    // eslint-disable-next-line compat/compat
    const url = new URL(productUrl)
    const pathName = url.pathname

    return await fetch(`${pathName}?section_id=product-card-quick-add`)
      .then(response => response.text())
      .then(responseText => {
        const innerHTML = new DOMParser()
          .parseFromString(responseText, 'text/html')
          .querySelector('.js-QuickAddToCart_Modal').innerHTML
        return innerHTML
      })
  }

  scrollToPreviousPosition () {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'
    }

    const savedHandle = sessionStorage.getItem('BAO-PlpClickedProduct')

    if (!savedHandle) return

    const offsetTop = this.getOffsetTop(savedHandle)

    window.scrollTo({
      top: offsetTop,
      behavior: 'smooth',
    })

    sessionStorage.removeItem('BAO-PlpClickedProduct')
  }

  setClickedProduct (event) {
    const target = event.target.closest('[data-product-handle]')
    const productHandle = target?.getAttribute('data-product-handle')

    if (!productHandle) return

    sessionStorage.setItem('BAO-PlpClickedProduct', productHandle)
  }

  getOffsetTop (handle) {
    const targetElement = document.querySelector(`[data-product-handle="${handle}"]`)
    const headerWrapper = document.querySelector('[data-restore-scroll-external-el="header"]')
    const searchBar = document.querySelector('[data-restore-scroll-external-el="search"]')

    const headerOffset = headerWrapper ? headerWrapper.offsetHeight : 0
    const searchBarOffset = searchBar ? searchBar.offsetHeight : 0
    const targetElementOffset = targetElement ? targetElement.getBoundingClientRect().top : 0

    return targetElementOffset + window.scrollY - headerOffset - searchBarOffset
  }
}

customElements.define('algolia-card', AlgoliaCard)
